import React from "react";
import { Link } from "react-router-dom";
import { Mail, Linkedin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_workflow-builder-125/artifacts/y4lualkn_Zelaflo%20Logo.svg";

const legalLinks = [
  { to: "/legal/privacy-policy", label: "Privacy Policy" },
  { to: "/legal/terms-of-service", label: "Terms of Service" },
  { to: "/legal/cookie-policy", label: "Cookie Policy" },
  { to: "/legal/refund-policy", label: "Refund Policy" },
  { to: "/legal/service-level-agreement", label: "Service Level Agreement" },
  { to: "/legal/data-processing-agreement", label: "Data Processing Agreement" },
];

export const Footer = () => {
  return (
    <footer className="relative border-t pt-20 pb-8" style={{ borderColor: "var(--border)", backgroundColor: "var(--bg)" }} data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <img src={LOGO_URL} alt="Zelaflo Labs logo" className="h-9 w-auto" loading="lazy" />
              <span className="font-heading font-bold tracking-tight text-lg" style={{ color: "var(--text)" }}>
                ZELAFLO <span className="text-[#7B2FBE]">LABS</span>
              </span>
            </Link>
            <p className="text-sm max-w-xs" style={{ color: "var(--text-muted)" }}>Your Business on Autopilot.</p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-widest" style={{ color: "var(--text)" }}>Company</h4>
            <ul className="space-y-3 text-sm" style={{ color: "var(--text-muted)" }}>
              <li><Link to="/" className="hover:text-[#7B2FBE] transition-colors">Home</Link></li>
              <li><Link to="/how-it-works" className="hover:text-[#7B2FBE] transition-colors">How It Works</Link></li>
              <li><Link to="/services" className="hover:text-[#7B2FBE] transition-colors">Services</Link></li>
              <li><Link to="/pricing" className="hover:text-[#7B2FBE] transition-colors">Pricing</Link></li>
              <li><Link to="/blog" className="hover:text-[#7B2FBE] transition-colors" data-testid="footer-blog-link">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-[#7B2FBE] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-widest" style={{ color: "var(--text)" }}>Legal</h4>
            <ul className="space-y-3 text-sm" style={{ color: "var(--text-muted)" }}>
              {legalLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-[#7B2FBE] transition-colors" data-testid={`footer-legal-${l.to.split("/").pop()}`}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-widest" style={{ color: "var(--text)" }}>Contact</h4>
            <ul className="space-y-3 text-sm" style={{ color: "var(--text-muted)" }}>
              <li>
                <a
                  href="mailto:hello@zelaflo.com"
                  className="inline-flex items-center gap-2 hover:text-[#7B2FBE] transition-colors"
                  data-testid="footer-email-link"
                >
                  <Mail size={16} /> hello@zelaflo.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/zelaflo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[#7B2FBE] transition-colors"
                  data-testid="footer-linkedin-link"
                >
                  <Linkedin size={16} /> LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t flex flex-col md:flex-row justify-between items-center gap-4" style={{ borderColor: "var(--border)" }}>
          <p className="text-xs" style={{ color: "var(--text-subtle)" }}>© 2026 Zelaflo Labs. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
